module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Headphones.aaf014f3.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Headphones.svg
// module id = 1615
// module chunks = 0